module.exports = __webpack_public_path__ + "fonts/6cc67ec.woff2";